import React, { useEffect, useRef, useState } from "react";
import Header from "../../Home/Header";
import Navbar from "../../commons/Navbar";
import "../../Home/style.css";
import HeaderBox from "../../Home/HeaderBox";
import styles from "../ProductStyle.module.css";
import Arr from "../../assets/product.json";

const CustomDesignedTool = ({ navigationId, setNavigationId }) => {
  const windowSizeResolution = useRef(null, "windowSizeResolution");
  useEffect(() => {
    window.innerWidth === 1536
      ? (windowSizeResolution.current.id = "rest-banner")
      : (windowSizeResolution.current.id = "rest-banner");
  }, []);
  const alphabetArray = "abcdefghijklmnopqrstuvwxyz".split("");
  // const [navId, setNavId] = useState(1);
  // const handleCallback = (childdata) => {
  //   setNavigationId(childdata);
  // };
  // console.log(Arr[0].megaMenu[0].subMenu);
  return (
    <>
      <div className="rest-banner" ref={windowSizeResolution}>
        <HeaderBox id={navigationId} />
        <Header />
        <Navbar setNavigationId={setNavigationId} />
        <div className="container-fluid">
          <div className={`row min_height ${styles.ContentContainer}`}>
            <div>
              <h2>Custom Designed Tool Discs</h2>
              <h5>
                Sphoorti India has been a leading tool holder and accessory
                manufacturer for a decade, catering nothing but the best to the
                customers. We understand all industry requirements are
                different, and hence we make customised products for our
                customers: we custom design tool discs, tool holders and other
                accessories.
              </h5>
            </div>
            <div className={styles.DictionaryContainer}>
              {alphabetArray.map((alpha, i) => {
                return (
                  <>
                    {Arr[3].megaMenu.some((element) =>
                      element.title.startsWith(alpha.toUpperCase())
                    ) && (
                      <div className={styles.AlphaContainer} key={i}>
                        <b>{alpha.toUpperCase()}</b>
                        <ul>
                          {Arr[3].megaMenu.map((element, index) => {
                            return (
                              element.title.startsWith(alpha.toUpperCase()) && (
                                <li key={index}>
                                  {
                                    <a
                                      // onClick={() => handleSelectManu(element)}
                                      href={`https://www.sphoorti.com${element.link}`}
                                    >
                                      {element.title}
                                    </a>
                                  }
                                </li>
                              )
                            );
                          })}
                        </ul>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </div>
        {/* <SideBanner />
        <About /> */}
        {/* <div className="container border-1">
          <div className="row ">
            <div className="col-md-3 border-1 d-flex align-items-end ">
              <SideBanner parentCallback={handleCallback} />
            </div>
            <div className="col-md-8 " style={{ marginTop: "2%" }}>
              {navId === 0 && <Banner />}
              {navId === 1 && <About />}
              {navId === 2 && <Products />}
              {navId === 3 && <Infrastructure />}
              {navId === 4 && <NewsAndEvents />}
              {navId === 5 && <Catalogue />}
            </div>
          </div>
        </div> */}
        {/* <div className="container ">
          <div className="row">
            <div className="col-md-10 " style={{ marginTop: "2%" }}>
              {navId === 0 && <Banner />}
              {navId === 1 && <About />}
              {navId === 2 && <Products />}
              {navId === 3 && <Infrastructure />}
              {navId === 4 && <NewsAndEvents />}
              {navId === 5 && <Catalogue />}
            </div>
          </div>
          <div className="row">
            <div className="col-10">
              <SideBanner parentCallback={handleCallback} />
            </div>
          </div>
        </div> */}
      </div>

      {/* <br /> */}
    </>
  );
};

export default CustomDesignedTool;
